export const environment = {
  production: true,
  apiUrl: 'http://api.haulex.com/api',
  quoteFormUrl: 'https://cdn.haulex.com',
  candFormUrl: 'https://cdn.haulex.com'
}